import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Geofence } from '@/types'
import { distanceMeters } from '@/utils/commonUtils'

export function useGeofence (pointList: Geofence[], onEnter: (g: Geofence) => void) {
  const geofences = ref<Geofence[]>(pointList)
  const watching = ref(false)
  let watchId: number | null = null

  const evaluate = (lat: number, lng: number) => {
    for (const g of geofences.value) {
      const d = distanceMeters({ lat, lng }, { lat: g.lat, lng: g.lng })
      if (d <= g.radius) {
        onEnter(g)
      }
    }
  }

  async function start () {
    if (!('geolocation' in navigator)) {
      console.error('geolocation not supported')
      return
    }

    if ('permissions' in navigator) {
      const permisson = await navigator.permissions.query({ name: 'geolocation' })
      if (permisson.state === 'denied') {
        console.error('permission denied')
        return
      }
    }

    if (watching.value) {
      return
    }

    watching.value = true
    watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords
        evaluate(latitude, longitude)
      },
      (err) => console.warn('geo error', err),
      { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
    )
  }

  function stop () {
    if (watchId != null) {
      navigator.geolocation.clearWatch(watchId)
      watchId = null
    }
    watching.value = false
  }

  onMounted(() => {})
  onBeforeUnmount(stop)

  return { geofences, watching, start, stop }
}
